module.exports = "data:image/png;base64,UklGRm4BAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSJ4AAAABt6CgjSQ1dgzPpOQjIoBZX6lVvQ23c39Y81LhsG0jR/KON93N7P9tmv57vVBDRP8nAI+shfjKtpbxg7T9b5fJC9v2Go5ufJC23CvCMUwAsO3Ze42R5zCCbbsFqmoK5zCW5a5IhiCQ3ypl3rIC4YG2XMGmmsI5jBDds/cjJZ7dCEB0uVeEo5vgTt1eUS8jnkXX77xM8C46pxFfmTPxCFZQOCCqAAAAsAMAnQEqEAAQAAIANCWcAUwBiiGYJNJ6gHoAfoAfePdl7KEBsHAA/q0+vr4InrW+DkC1Y59vXJ6iNYdJ1HUWktDh0e2uTyOmt5K05CzPd/f3N6+aFcMzkL7cQBZ/q83ZM/AUUzmB1yyz3f81n8ohiEMNNq1jVfU/mY6PsfOdsFjHyhedNFT6ZW1ojuOxZ17CklCcK1l4EuVCMkLcxQJHXvZ0S5WDArCcAAA="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/icons/event_custom.png
// module id = 27
// module chunks = 0